
<div class="collection-search-add">
  <search
    global
    placeholder="Search Sales History and Ladder cards"
    :source="searchSource"
    :sort="sort"
    v-bind="$attrs"
    @select="handleSelect"
  >
    <template #header>
      <div class="header">
        <pill
          v-for="(option, i) in sourceOptions"
          :key="i"
          :active="option.value === searchSource"
          @click="searchSource = option.value"
        >
          <icon :name="option.icon" />
          <span class="pill-text">{{ option.label }}</span>
        </pill>
      </div>
    </template>

    <template #default="slotProps">
      <card-list-item
        v-if="slotProps.source === 'cards'"
        :card="slotProps.item"
        :fields="['currentValue']"
      />

      <sales-list-item
        v-else-if="slotProps.source === 'salesarchive'"
        split
        :item="slotProps.item"
      >
        <verified-icon v-if="slotProps.item.cardId" />
      </sales-list-item>
    </template>
  </search>

  <div class="other-options">
    <p>OR</p>

    <div class="grid">
      <div>
        <cta-card
          icon="assignment_turned_in"
          title="Enter Graded Card Cert"
          description="Enter the PSA, BGS, SGC or CGC cert from your slab and we will pull all the details from the grading company and fill out your collection card for you."
          @click="showCertInput = !showCertInput"
        />

        <align v-show="showCertInput" class="cert-input" flex>
          <text-input
            v-model="certInput"
            label="Cert #"
            placeholder="63444200"
          />

          <select-input
            v-model="graderInput"
            label="Grader"
            :options="graderOptions"
          />

          <btn
            :loading="addingFromCert"
            loading-text="Submitting"
            @click="addCardFromCert"
          >
            Submit
          </btn>
        </align>
      </div>

      <cta-card
        icon="drive_file_move_rtl"
        title="Cert CSV"
        description="Upload your PSA, BGS, SGC or CGC cards in bulk. We will quickly fetch all these cards from the grading company and get them into your collection."
        @click="addCertUpload"
      />

      <cta-card
        icon="view_carousel"
        title="Add Manually"
        description="Not seeing your card in the search? Don't worry we can help you quickly add the card to your collection and determine the value."
        @click="addCustom"
      />

      <cta-card
        icon="file_upload"
        title="Upload CSV"
        description="Upload to your collection in bulk. We will quickly get all these cards into your collection with estimated values."
        @click="addUpload"
      />
    </div>
  </div>
</div>
